
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.992 14.434 16.656 4.588a1.004 1.004 0 0 0-1.312 0L4.008 14.434a.75.75 0 1 0 .984 1.132L6 14.691V26.25A1.752 1.752 0 0 0 7.75 28h16.5A1.752 1.752 0 0 0 26 26.25V14.69l1.008.876a.75.75 0 0 0 .984-1.132ZM10.5 26.5V19H14v7.5h-3.5Zm14-.25a.25.25 0 0 1-.25.25H15.5v-9H9v9H7.75a.25.25 0 0 1-.25-.25V13.388L16 6.005l8.5 7.383V26.25ZM16 10.5a1.245 1.245 0 1 0 .011 2.49A1.245 1.245 0 0 0 16 10.5Zm7 7v6h-6v-6h6ZM21.5 19h-3v3h3v-3Z"}})])
          )
        }
      }
    